import React from 'react'

const Divider = () => {
  return (
    <div className="divider-container">
    <div className="line"></div>
    <span className="divider-text">Or</span>
    <div className="line"></div>
</div>

  )
}

export default Divider